import { Component, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../';
import { InputModalData, InputModalActions } from './input.modal.provider';
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
    templateUrl: './input.modal.component.html',
    styleUrls: ['./input.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InputModalComponent extends BaseComponent {

    public data: InputModalData;
    public value: string;
    public form: FormGroup;

    constructor(private dialogRef: MatDialogRef<InputModalComponent>,
                private actions: InputModalActions,
                private formBuilder: FormBuilder,
                data: InputModalData) {
        super();
        this.data = Object.assign({}, data);
        if (this.data.inputModalValue) {
            this.value = this.data.inputModalValue;
        }
    }

    public ngOnInit() {
        this.form = this.formBuilder.group({
            'text': [null],
        });
    }

    public close(): void {
        if (this.actions.cancel) {
            this.actions.cancel();
        }

        this.dialogRef.close();
    }

    public confirm(event: ButtonTriggerEvent) {
        if (this.data.isAsync) {
            let oldFunc = event.complete;
            event.complete = () => {
                oldFunc();

                this.dialogRef.close();
            };

            this.actions.confirm(event, this.value);
        } else {
            this.actions.confirm(event, this.value);
            this.dialogRef.close();
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/input.modal/input.modal.component.ts